module.exports = __webpack_public_path__ + "img/TV_clean_box23.acf2e350.jpg";